import { allBudgetTypesOptions, allClassificationTypesOptions, allDataSourcesOptions, allMeasureUnitsOptions, allMonthsOptions, allMutuallyRedeemingLevelOptions, allMutuallyRedeemingOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions, allStatusOptions } from "../../common/baseOptions"
import { Template } from "../../common/types/Template"
import { cloneDeep } from 'lodash'
import { Report127ActFilterSettings } from "./settings/Report127ActFilterSettings"
import { Report127ActFilterOptions } from "./options/Report127ActFilterOptions"
import { Option } from "../../common/types/Option"
import { StatusType } from "../../common/types/roots/fields"


export const actStatusOptionValues: StatusType[] = [
    '39',
    '26'
]
export const actStatusOptions: Option<StatusType>[] = allStatusOptions.filter(
    o => actStatusOptionValues.includes(o.value)
)

const fs: Report127ActFilterSettings = {
    reportName: '1-27-ACT',

    reportType: 'REGULATED',
    classificationType: 'MIXED',
    dataSource: 'LOADER',
    periodicity: 'MONTH',

    region: '',
    mutuallyRedeeming: 'ONLY',
    mutuallyRedeemingLevels: [],
    budgetTypes: [],
    statuses: [],
    measureUnit: 'TENGE',
    year: (new Date().getFullYear()),
    month: 1,
    roundUpTo: null
}

export const report127ActBaseTemplate: Template = {
    id: null,
    name: 'Акт сверки',
    excelName: null,
    description: null,
    category: '70',
    regions: [],
    userId: '',
    filterSettings: fs
}

export const report127ActFilterOptions: Report127ActFilterOptions = {
    // Base:
    key: '1-27-ACT',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions),
    dataSources: cloneDeep(allDataSourcesOptions),
    // Custom:
    regions: [], // Загружается с бэка
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    statuses: cloneDeep(actStatusOptions),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    months: cloneDeep(allMonthsOptions),
}
